import http from '@root/utils/axios/admin';

let state = {
    DashboardStatisticsList: [],
}

let actions = {

    fetchDashboardStatisticsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/dashboard-statistics', { params: filter }).then((response) => {
                commit('setDashboardStatistics', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },


}


let mutations = {
    setDashboardStatistics(state, data) {
        state.DashboardStatisticsList = data;
    },

}

export default {
    state,
    actions,
    mutations
}